import { createSlice } from '@reduxjs/toolkit';
import { createSliceHook, makeActionCreator } from '../helpers';
import type {
  SegmentationDeleteParams,
  SegmentationServiceLockRequestParams,
  SegmentationUnlockParams,
} from './segmentation.type';

export type SegmentationEvent = {
  event: string;
  data: unknown;
};

export type SegmentationState = {
  lastEvent: SegmentationEvent | null;
};

const initialState: SegmentationState = {
  lastEvent: null,
};

const { act, actEmpty } = makeActionCreator<SegmentationState>();

export const segmentationSlice = createSlice({
  name: 'segmentation',
  initialState,
  reducers: {
    lockMeasurement: actEmpty<SegmentationServiceLockRequestParams>(),
    unlockMeasurement: actEmpty<SegmentationUnlockParams>(),
    deleteMeasurement: actEmpty<SegmentationDeleteParams>(),
    resetState: act(() => ({ lastEvent: null })),
    segmentationChanged: act<SegmentationEvent>(payload => ({
      lastEvent: payload,
    })),
  },
});

export const actions = {
  ...segmentationSlice.actions,
};

export const useSegmentationSlice = createSliceHook(
  segmentationSlice.name,
  actions
);
